import { computed } from 'vue'
import { groupFilterableValuesByKey } from '@scayle/storefront-nuxt'
import useNewPlp from '../../composables/plp/useNewPlp'
import { useRoute } from '#app/composables/router'
import { DEFAULT_SORT_VALUE_KEY } from '~/config/defaultConfigs'
import { INCLUDED_FILTERS } from '../../constants/filters'
import type { FilterItemWithValues } from '../../types/filter'

export default () => {
  const route = useRoute()
  const {
    applyFilters: _applyFilter,
    resetFilterUrl,
    activeFilters,
  } = useQueryFilterState({
    defaultSort: DEFAULT_SORT_VALUE_KEY,
  })

  const { filters, isActiveSalePeriod } = useNewPlp()

  const quickFilters = computed(() =>
    filters.value
      ? groupFilterableValuesByKey(
          filters.value as unknown as FilterItemWithValues[],
          isActiveSalePeriod.value
            ? INCLUDED_FILTERS
            : INCLUDED_FILTERS.filter((filter) => filter !== 'sale'),
        )
      : [],
  )

  const parseAndPreserveAttributeFilters = () => {
    // Attribute filters such as color should be preserved
    const attributeFilters: Record<string, any> = {}
    const keysToExclude = quickFilters.value.map((filter) => filter.key)
    const filtersFromQueryParams = JSON.parse(
      (route.query as any).filters || '{}',
    )
    for (const key of Object.keys(filtersFromQueryParams)) {
      if (!keysToExclude.includes(key.toLowerCase())) {
        attributeFilters[key] = filtersFromQueryParams[key]
      }
    }
    return attributeFilters
  }

  const applyFilters = (
    filter: Record<string, any>,
    preserveAttributeFilters = false,
  ) => {
    const attributeFilters: Record<string, any> =
      route.query && preserveAttributeFilters
        ? parseAndPreserveAttributeFilters()
        : {}
    const combinedFilters = { ...filter, ...attributeFilters }
    _applyFilter(combinedFilters)
  }

  return {
    applyFilters,
    resetFilterUrl,
    filters,
    activeFilters,
  }
}
